import { render } from "./WhatIsCermi.vue?vue&type=template&id=57ff1bae&scoped=true"
import script from "./WhatIsCermi.vue?vue&type=script&lang=js"
export * from "./WhatIsCermi.vue?vue&type=script&lang=js"

import "./WhatIsCermi.vue?vue&type=style&index=0&id=57ff1bae&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ff1bae"]])

export default __exports__